var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('upload',{on:{"uploaded":_vm.getNtms}}),_c('ntm-list',{staticClass:"pt-3",attrs:{"ntms":_vm.ntms},on:{"removeNtm":_vm.removeNtm}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }